import React, {useState} from 'react';
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {useTableRowStyles} from "./countries-table.styles";
import CountriesTableCell from "./CountriesTableCell";
import TableActionButtons from "../base-table/TableActionButtons";
import {TableActionsTypes} from "../../../types/TableTypes";
import {toggleQuickPanel} from "../quick-panel/store";
import {useDispatch} from "react-redux"
import {useRouteMatch} from "react-router-dom";
import history from '@history';
import ModalDialog from 'app/main/shared-components/modal-dialog/ModalDialog'
import {deleteCountry} from "../../configurations/store/countries/delete-country.slice";
import {useTranslation} from "react-i18next";


const CountriesTableRow = (props: any) => {
  const classes = useTableRowStyles();

  const dispatch = useDispatch();
  let {url} = useRouteMatch();
  const {row} = props;
  const {t} = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const tableActions: TableActionsTypes = {
    // onViewRow: (rowId: number) =>  alert('row: ' + rowId),
    onEditRow: (rowId: number) => {
      dispatch(toggleQuickPanel());
      history.push(`${url}/update/${rowId}`);
    },
    onDeleteRow: (rowId: string) => {
      setModalOpen(true);
    }
  }

  const translateModal = () => {
    let title = t("app.main.configuration.country.module.title", "Are you sure you want to delete country ");

    return title + row.name + ' ?';
  }

  return (
      <React.Fragment>
        <ModalDialog
            open={modalOpen}
            title={translateModal()}
            onOk={() => {
              dispatch(deleteCountry({id: row.id}));
            }}
            onCancel={() => setModalOpen(false)}/>
        <TableRow className={classes.root}>
          <TableCell style={{textAlign: 'center'}}>
            <CountriesTableCell {...props} content={[
              `${row.index}`
            ]}/>
          </TableCell>
          <TableCell style={{textAlign: 'center'}}>
            <CountriesTableCell {...props} content={[
              `${row.name}`
            ]}/>
          </TableCell>
          <TableCell style={{textAlign: 'center'}}>
            <CountriesTableCell {...props} content={[
              `${row.code}`
            ]}/>
          </TableCell>

          <TableCell style={{textAlign: 'center'}}>
            <TableActionButtons {...tableActions} rowId={row.id}/>
          </TableCell>

        </TableRow>
      </React.Fragment>
  );
};

export default CountriesTableRow;